import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "role-skill-tree-container"
};
import { ref, watch, computed } from 'vue';
import SkillsTree from '@/components/Skills/SkillsTree.vue';
import { request } from '@/manager/net_manager';
import { ElOption, ElRow, ElSelect } from 'element-plus';
import { convertTreeData, inApostleType, sortedSkillData } from '@/tools/utils';
import _ from 'lodash';
import store from "@/store";
export default {
  __name: 'RoleSkillTree',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    },
    organizationId: {
      type: [String, Number],
      required: true
    }
  },

  setup(__props) {
    const modeArray = [{
      label: '全览',
      value: -1
    }, {
      label: '公开',
      value: 0
    }, {
      label: '秘传',
      value: 1
    }];
    const props = __props; // refs

    const mode = ref(-1);
    const dataArray = ref([]);
    const treeData = ref({}); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4); // functions

    const getData = () => {
      request('skills/list/', {
        'role_id': props.roleId,
        'organization_id': props.organizationId
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response.data))
        if (response.code === 0) {
          treeData.value = {};
          dataArray.value = response.data;

          if (dataArray.value.length > 0) {
            treeData.value = convertTreeData(dataArray.value);
            treeData.value = sortedSkillData(structuredClone(treeData.value));
          }
        }
      });
    };

    const onModeChanged = () => {
      if (dataArray.value.length === 0) return;

      let buffer = _.cloneDeep(dataArray.value);

      if (mode.value === 0) {
        buffer = buffer.filter(item => !item.is_private);
      } else if (mode.value === 1) {
        buffer = buffer.filter(item => item.is_private);
      }

      treeData.value = convertTreeData(buffer);
      treeData.value = sortedSkillData(structuredClone(treeData.value));
    };

    watch(() => props.organizationId && props.roleId, () => getData(), {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(inApostleType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElSelect), {
          modelValue: mode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => mode.value = $event),
          placeholder: "一览方案",
          class: _normalizeClass(mode.value >= 0 ? 'selected-selector' : ''),
          "popper-class": "roleSkillsPopper",
          onChange: onModeChanged
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(modeArray, (item, index) => {
            return _createVNode(_unref(ElOption), {
              key: index,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue", "class"])]),
        _: 1
      })) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("div", {
        style: {
          "height": "1.5rem"
        }
      }, null, -1)), dataArray.value.length === 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        class: "empty-data-tips",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("text", {
          style: {
            "display": "flex"
          }
        }, "未检测到公开技能教导", -1)]))]),
        _: 1
      })) : treeData.value ? (_openBlock(), _createBlock(SkillsTree, {
        key: 2,
        data: treeData.value,
        "role-id": __props.roleId
      }, null, 8, ["data", "role-id"])) : _createCommentVNode("", true)]);
    };
  }

};